import {createStyles} from '@mantine/core';
import React from 'react';

import ModelTypeConstants from 'constants/ModelTypeConstants';
import Badge, {BadgeColor} from 'ui-library/Badge';

const useStyles = createStyles(() => ({
  templateBadge: {
    marginLeft: '-8px',
  },
}));

export default function ProcedureTemplateCollectibleBadge(): JSX.Element {
  const {classes} = useStyles();
  return (
    <Badge
      startingIcon={ModelTypeConstants.TEMPLATE_COLLECTION}
      color={BadgeColor.COLLECTIBLE_BLUE}
      className={classes.templateBadge}
    >
      Template
    </Badge>
  );
}
